<template>
    <div class="uncompleted-projec-item">
       <div class="info">
           <div class="name" v-text="project.name"></div>
           <div class="number text-muted" v-text="project.number"></div>
           <div class="started_at text-muted" v-text="shortDate(project.started_at)"></div>
       </div>
        <field-datetime label="Target Date" v-model="form.expected_target_date" :with-time="false" @input="updateTargetDate($event)"></field-datetime>
    </div>
</template>
<script>
    export default {

        props: {
            project: {
                type: Object,
                required: true,
            }
        },

        data(){
            return {
                form: new Form({
                    expected_target_date: this.project.expected_target_date
                }).dontClear()
            }
        },

        methods:{
            updateTargetDate(event){
                this.form.post(`/projects/uncompleted/${this.project.slug}`).then(response => {
                    Toast.success(`${this.project.name} project target date updated succesfully!`);
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            }
        }
    }
</script>
